// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bT1xRTlQbdtXTYSGfdYm {
  height: 400px;
  overflow-y: scroll;
  border: 1px solid #eee;
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/admin-pages/PropertySets/Item/Components/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;AAAF","sourcesContent":["\n.tableContainer {\n  height: 400px;\n  overflow-y: scroll;\n  border: 1px solid #eee;\n  padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `bT1xRTlQbdtXTYSGfdYm`
};
export default ___CSS_LOADER_EXPORT___;
